The hirer the browser token is scoped to.

This will be `null` when queried with a partner token.
